import { Aspect } from '@teambit/harmony';

export const IsolatorAspect = Aspect.create({
  id: 'teambit.component/isolator',
  dependencies: [],
  defaultConfig: {},
});
